type Dimensions = { width: number; height: number };

export const IMAGE_NONPROFIT_DEFAULT_MIN_DIMENSIONS: Dimensions = {
  width: 1900,
  height: 950,
};

export const STARS_DIMENSIONS: Dimensions = { width: 874, height: 335 };
